import React, { useState } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import { InterUserMangementServices } from "../services/InternalUserMangementServices";

export default function UserSelect({ onChange, teamUserId, assignedTo }) {
  const [selectedOption, setSelectedOption] = useState(null);

  const loadUserOptions = async (searchKey, loadedOptions, { page }) => {
    try {
      const limit = 10;
      const res = await InterUserMangementServices.getTeamUser(
        limit,
        page,
        searchKey || "",
        1
      );
      console.log("user list:", res?.data?.teamUsers);
      const users = res?.data?.teamUsers || [];
      const hasMore = res?.data?.curentPage < res?.data?.totalPages;

      const options = users.map((user) => ({
        value: user.id,
        label: user.fullName,
      }));

      return {
        options,
        hasMore,
        additional: {
          page: page + 1,
        },
      };
    } catch (err) {
      console.error("Error fetching users:", err);
      return {
        options: [],
        hasMore: false,
        additional: { page },
      };
    }
  };

  return (
    <AsyncPaginate
      isClearable
      isDisabled={!!assignedTo}
      debounceTimeout={300}
      additional={{ page: 1 }}
      loadOptions={loadUserOptions}
      value={selectedOption}
      onChange={(option) => {
        setSelectedOption(option || null);
        console.log("user selected option:", option);
        onChange(option); // return userId to parent
      }}
      placeholder="FILTER USER WISE"
    />
  );
}
